import type { ApiClient } from '@travel/api-client';

import type { CardItems } from 'Card-Types';

export const fetch = (http: ApiClient): Promise<CardItems[]> =>
  http
    .get('/consumer/member/cards', { ignoreCommonErrorHandler: true })
    .then((data: CardItems[]) => data);
